<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Dettaglio Analisi</h4>
    <button type="button" class="text-white close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body custom-modal">
    <div class="form-group row">
        <div class="col-6 text-left">
            <label class="bold ml-4">Piano Lavori</label>
        </div>
        <div class="col-6">
            <span>{{data?.piano_lavori}}</span>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-6 text-left">
            <label class="bold ml-4">Anno Piano Lavori</label>
        </div>
        <div class="col-6">
            <span>{{data?.anno_piano_lavori}}</span>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-6 text-left">
            <label class="bold ml-4">Nome Sito</label>
        </div>
        <div class="col-6">
            <span>{{data?.name}}</span>
        </div>
    </div>
    <div class="form-group row" *ngIf="data?.lat">
    <div class="col-6 text-left">
        <label class="bold ml-4">Latitudine</label>
    </div>
    <div class="col-6">
        <span>{{data?.lat | number: '1.6-6'}}</span>
    </div>
    </div>
    <div class="form-group row" *ngIf="data?.lon">
    <div class="col-6 text-left">
        <label class="bold ml-4">Longitudine</label>
    </div>
    <div class="col-6">
        <span>{{data?.lon | number: '1.6-6'}}</span>
    </div>
    </div>
    <div class="form-group row" *ngIf="data?.comune">
        <div class="col-6 text-left">
            <label class="bold ml-4">Comune</label>
        </div>
        <div class="col-6">
            <span>{{data?.comune}}</span>
        </div>
    </div>
    <div class="form-group row" *ngIf="data?.provincia">
        <div class="col-6 text-left">
            <label class="bold ml-4">Provincia</label>
        </div>
        <div class="col-6">
            <span>{{data?.provincia}}</span>
        </div>
    </div>
    <div class="form-group row" *ngIf="data?.regione">
        <div class="col-6 text-left">
            <label class="bold ml-4">Regione</label>
        </div>
        <div class="col-6">
            <span>{{data?.regione}}</span>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-6 text-left">
            <label class="bold ml-4">Colore</label>
        </div>
        <div class="col-6 d-flex align-items-center">
            <div class="box-color" placement="top" [ngbTooltip]="data?.colore | uppercase" [ngStyle]="{'background': data?.colore}"></div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-6 text-left">
            <label class="bold ml-4">SR</label>
        </div>
        <div class="col-6">
            <div ngbTooltip="disponibilità per la ricerca">{{data?.sr}}</div>
        </div>
    </div>
    <div class="form-group row" *ngIf="data?.codice_cliente_1">
        <div class="col-6 text-left">
            <label class="bold ml-4">Codice cliente 1</label>
        </div>
        <div class="col-6">
            <span>{{data?.codice_cliente_1}}</span>
        </div>
    </div>
    <div class="form-group row" *ngIf="data?.codice_cliente_2">
        <div class="col-6 text-left">
            <label class="bold ml-4">Codice cliente 2</label>
        </div>
        <div class="col-6">
            <span>{{data?.codice_cliente_2}}</span>
        </div>
    </div>
    <div class="form-group row" *ngIf="data?.codice_cliente_3">
        <div class="col-6 text-left">
            <label class="bold ml-4">Codice cliente 3</label>
        </div>
        <div class="col-6">
            <span>{{data?.codice_cliente_3}}</span>
        </div>
    </div>
    <div class="form-group row" *ngIf="data?.altezza_centro_elettrico_m">
        <div class="col-6 text-left">
            <label class="bold ml-4">Altezza centro elettrico</label>
        </div>
        <div class="col-6">
            <span>{{data?.altezza_centro_elettrico_m}}</span>
        </div>
    </div>
    <div class="form-group row" *ngIf="data?.raggio_area_di_ricerca_m">
        <div class="col-6 text-left">
            <label class="bold ml-4">Raggio area ricerca</label>
        </div>
        <div class="col-6">
            <span>{{data?.raggio_area_di_ricerca_m}}</span>
        </div>
    </div>
    <div class="form-group row" *ngIf="groups">
        <div class="col-6 text-left">
            <label class="bold ml-4">Gruppi</label>
        </div>
        <div class="col-6">
            <span>{{groups}}</span>
        </div>
    </div>

    <div class="form-group row" *ngIf="users">
        <div class="col-6 text-left">
            <label class="bold ml-4">Utente</label>
        </div>
        <div class="col-6">
            <span>{{users}}</span>
        </div>
    </div>

</div>
<div class="modal-footer" *ngIf="apriDettaglioAnalisi">
    <div  class="align-self-center">
        <button type="button" ngbTooltip="Apri dettaglio analisi"
        routerLink="/mappa/sidebar/analisi/dettaglio-analisi/{{data?.id}}" placement="left" class="btn button-icon mr-1" (click)="modal.dismiss()"> Apri dettglio analisi
        </button>
    </div>
</div> 
<!-- <div class="modal-footer">
    <button type="button" class="btn btn-bg-outline" (click)="modal.dismiss()">
        Chiudi
    </button>
</div> -->